import _extends from "@babel/runtime/helpers/esm/extends";
var _IconClose;
import { Box, Modal } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Button from "../../atoms/Button";
import { IconClose } from "../../atoms/Icon";
import Typography from "../../atoms/Typography";
import colors from "../../theme/colors";
import { disableScrollBody } from "../../utils/disableScrollBody";
import { renderIcon } from "../EStoreProductDetail/Option/Platform";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ModalSelectPlatform(props) {
  const {
    open,
    onClose,
    titleModalSelectPlatform,
    listPlatform = [],
    titleButtonBuy = {},
    onClickBuy
  } = props;
  const [selectPlatForm, setSelectPlatform] = useState({});
  useEffect(() => {
    if (typeof window !== "undefined") {
      disableScrollBody(open);
    }
    if (!open) {
      setSelectPlatform({});
    }
  }, [open]);
  const renderTitle = title => {
    switch (title) {
      case "ps4":
      case "ps5":
        return titleButtonBuy?.ps || "";
      case "pc":
      case "steam":
        return titleButtonBuy?.stream || "";
      case "xboxo":
      case "xbox":
        return titleButtonBuy?.xbox || "";
      case "nintendo":
        return titleButtonBuy?.nintendo || "";
      default:
        return "Buy now";
    }
  };
  const renderSizeForPlatform = pl => {
    switch (pl) {
      case "ps4":
      case "ps5":
        return {
          width: {
            xs: "32px",
            md: "68px"
          },
          height: {
            xs: "32px",
            md: "68px"
          }
        };
      case "pc":
      case "steam":
        return {
          width: {
            xs: "23px",
            md: "49px"
          },
          height: {
            xs: "23px",
            md: "49px"
          }
        };
      case "xboxo":
      case "xbox":
        return {
          width: {
            xs: "32px",
            md: "68px"
          },
          height: {
            xs: "32px",
            md: "68px"
          }
        };
      case "nintendo":
        return {
          width: {
            xs: "20px",
            md: "40px"
          },
          height: {
            xs: "20px",
            md: "40px"
          }
        };
      default:
        return {};
    }
  };
  return /*#__PURE__*/_jsx(Modal, {
    open: open,
    sx: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      pointerEvents: "auto"
    },
    children: /*#__PURE__*/_jsx(Box, {
      sx: {
        width: "100%",
        height: "100%",
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center"
      },
      onClick: onClose,
      children: /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: "flex",
          flexDirection: "column",
          width: {
            xs: "310px",
            md: "636px"
          },
          padding: {
            xs: "56px 28px",
            md: "60px 44px"
          },
          maxWidth: "642px",
          background: "#fff",
          borderRadius: "10px",
          position: "relative"
        },
        onClick: e => {
          e.stopPropagation();
        },
        children: [/*#__PURE__*/_jsx(Box, {
          sx: {
            position: "absolute",
            top: "16px",
            right: "16px",
            cursor: "pointer"
          },
          onClick: onClose,
          children: _IconClose || (_IconClose = /*#__PURE__*/_jsx(IconClose, {
            htmlColor: "#C1C1C1"
          }))
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "h5",
          color: colors.primary.bandaiNamcoBlack,
          children: titleModalSelectPlatform
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            flex: 1,
            display: "flex",
            flexWrap: "wrap",
            padding: {
              xs: "32px 0px",
              md: "48px 0px"
            },
            gap: {
              xs: "12px",
              md: "22px"
            }
          },
          children: !!listPlatform?.length && listPlatform?.map(pl => {
            return /*#__PURE__*/_jsx(Box, {
              sx: {
                width: {
                  xs: "76px",
                  md: "168px"
                },
                minWidth: {
                  xs: "76px",
                  md: "168px"
                },
                height: {
                  xs: "56px",
                  md: "117px"
                },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid",
                borderColor: pl.id === selectPlatForm?.id ? colors.secondary.bandaiNamcoBlue : colors.neutral.neutral5,
                borderRadius: "10px",
                cursor: "pointer",
                transition: "all 0.3s",
                "& svg": _extends({}, renderSizeForPlatform(pl.titleIcon || ""), {
                  "& path": {
                    fill: pl.id === selectPlatForm?.id ? `${colors.secondary.bandaiNamcoBlue}` : "#000000"
                  }
                }),
                "&:hover": {
                  borderColor: colors.secondary.bandaiNamcoBlue,
                  "& path": {
                    fill: `${colors.secondary.bandaiNamcoBlue}`
                  }
                }
              },
              onClick: () => setSelectPlatform(pl),
              children: renderIcon(pl.titleIcon)
            });
          })
        }), /*#__PURE__*/_jsx(Button, {
          variant: !selectPlatForm?.titleIcon ? "primary" : "primaryDark",
          onClick: () => {
            onClickBuy?.({
              idPlatform: selectPlatForm?.id
            });
            onClose();
          },
          disabled: !selectPlatForm?.titleIcon,
          children: renderTitle(selectPlatForm?.titleIcon)
        })]
      })
    })
  });
}